import { render, staticRenderFns } from "./MenuEditor.vue?vue&type=template&id=5be1cb44"
import script from "./MenuEditor.vue?vue&type=script&lang=js"
export * from "./MenuEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports